module.exports = __webpack_public_path__ + "img/btn-add.cd2e83a1.svg";